// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"2414ccf6","348":"579f3ceb","396":"9575a7e1","489":"01993abd","507":"460b8f30","548":"476b1b4a","556":"f923245d","717":"97d93b3e","736":"ec8ff3a8","990":"34dc1dda"}[chunkId] + ".chunk.js";
};